module.exports = __webpack_public_path__ + "static/img/线下活动-POSM.d874c67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10011/线下活动-POSM.png
// module id = jluW
// module chunks = 1